import React from 'react';
import ReactDOM from 'react-dom';
//import './index.css';
import { css } from 'emotion';

//CSS Styles
//Style for answer boxes
const cssAnswer = css`
    background: #fff;
    border: 1px solid #999;
    float: none;
    font-size: 14px;
    font-family: 'Open Sans', serif;
    font-weight: light;
    line-height: 16px;
    height: 60px;
    margin: 5px;
    padding: 5px;
    text-align: center;
    width: 150px;
    align-content: left;
    border-radius: 8px;
    &:hover {
    background: #F99242;
    color: #fff
}
`
const cssBlank = css`
  ${cssAnswer};
    border: none;
      &:hover {
    background: #fff;
    color: #fff
}
`
//Style for answer box after it's been the correct answer
const cssAnswerCorrect = css`
    ${cssAnswer};
    background: #42BFF9;
    color: #ffffff;
`
//Style for the entire game
const cssGame = css`
    column-count: 3;
    -moz-column-count: 3;
    -webkit-column-count: 3;
    width: 600px;
    height: 420px;
    border: 1px solid #999;
`
//Style for A TOMATO FLAMES
const cssHeader = css`
    letter-spacing: 1px;
    column-span: all;
    text-align: center;
    font-size: 23px;
    font-family: 'Helvetica Neue';
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-bottom: 10px;
`
//Style for each letter in A TOMATO FLAMES
const cssHeaderLetter = css`
    color: black;
    border: 1px solid #515151;
    padding: 5px;
    margin: 5px;
    border-radius: 30px;
    width: 37px;
    height: 25px;
`
//Turns active letter blue
const cssHeaderLetterHighlighted = css`
    ${cssHeaderLetter};
    background: #F99242;
    color: #ffffff;
`
//Turns answered letter green
const cssHeaderLetterComplete = css`
    ${cssHeaderLetter};
    background: #42BFF9;
    color: #ffffff;
`

//Style for title page
const cssGame0 = css`
    align-content: center;
    width: 600px;
    height: 400px;
    border: 1px solid #999;
    border-radius: 10px;
`

//Style for instructions
const cssInstructions = css`
    font-size: 13px;
    text-align: center;
    font-family: open sans;
    font-weight: 400;
    column-span: all;
    margin-bottom: 20px;
    padding-left: 25px;
    padding-right: 25px;
`
//Style for Score
const cssScore = css`
    font-size: 13px;
    text-align: center;
    font-family: open sans;
    font-weight: 400;
    column-span: all;
    margin-top: 80px;
    margin-bottom: 20px;
    padding-left: 60px;
    padding-right: 60px;
`

//Style for start button
const cssStartButton = css`
    background: #e5e6e8;
    font-family: open sans;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 2px;
    border: 1px solid black;
    padding: 6px 35px;
    border-radius: 4px;
    align-content: center;
    column-span: all;
    margin-left: 240px;
    &:hover {
      background: #ffffff
},
`
//Style for title
const cssTitle = css`
    width: 500px;
    align-content: center;
    text-transform: uppercase;
    font-family: open sans;
    letter-spacing: 3px;
    font-size: 24px;
    column-span: all;
    margin-top:100px;
    margin-left: 180px;
    margin-bottom: 10px;
`

//Array containing all the answer strings in the correct order
var answerKey = [
        "Anti-collision lights",
        "Tachometer",
        "Oil pressure gauge",
        "Manifold pressure gauge",
        "Airspeed indicator",
        "Temperature gauge",
        "Oil temperature gauge",
        "Fuel-gauge",
        "Landing gear position indicator",
        "Altimeter",
        "Magnetic compass",
        "Emergency locator transmitter (ELT)",
        "Safety belt"
    ];

//React component for answers
class Answer extends React.Component {
    render(){
        return(
            <button className={this.props.style} onClick={this.props.onClick}>
                {this.props.value}
            </button>
        );
    }
}

//React component for start button
function StartButton(props){
    return(
        <button className={cssStartButton} onClick={props.onClick}>{props.value}</button>
    );
}

//React component of entire game
class Game extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            answers: [
        ["Anti-collision lights", false],
        ["Tachometer", false],
        ["Oil pressure gauge", false],
        ["Manifold pressure gauge", false],
        ["Airspeed indicator", false],
        ["Temperature gauge", false],
        ["Oil temperature gauge", false],
        ["Fuel-gauge", false],
        ["Landing gear position indicator", false],
        ["Altimeter", false],
        ["Magnetic compass", false],
        ["Emergency locator transmitter (ELT)", false],
        ["Safety belt", false]
    ]
        }
        this.state = {answers: shuffle(this.state.answers),//randomize order of answers
                     question: 0,
                     mainState: 0,//0 for start screen, 1 for game, 2 for results
                     onFirstTry: [true, true, true, true, true, true, true, true, true, true, true, true, true]};
    }
    
    //Function that checks if the clicked answer is right
    checkAnswer = function(selectedAnswer){
        //console.log('clicked');
        //console.log(selectedAnswer);
        //console.log(answerKey[this.state.question]);
        if(answerKey[this.state.question] === selectedAnswer){
            var newAnswers = this.state.answers.slice();
            for(var i = 0; i < this.state.answers.length; i++){
                if(newAnswers[i][0] === selectedAnswer){
                    newAnswers[i][1] = true;
                    break;
                }
            }
            var newQuestion = this.state.question + 1;
            this.setState({answers: newAnswers,
                          question: newQuestion});
            if(newQuestion === 13){
                this.setState({mainState: 2});
            }
        }
        else{
            var onFirstTryArray = this.state.onFirstTry.slice();
            onFirstTryArray[this.state.question] = false;
            this.setState({onFirstTry: onFirstTryArray});
        }
    }
    
    //Function to set up game
    setupGame = function(){
        console.log('Setup game');
        var newAnswers = this.state.answers.slice();
        for(var i = 0; i < this.state.answers.length; i++){
                newAnswers[i][1] = false;
        }
        newAnswers = shuffle(newAnswers);
        this.setState({answers: newAnswers,//randomize order of answers
                     question: 0,
                     mainState: 1,//0 for start screen, 1 for game, 2 for results
                     onFirstTry: [true, true, true, true, true, true, true, true, true, true, true, true, true]});
    }
    
    //Render each answer with text drawn from shuffled answers
    renderAnswer(i){
        this.checkAnswer.bind(this);
        return(
            <Answer style={this.state.answers[i][1]?cssAnswerCorrect:cssAnswer}
                value = {this.state.answers[i][0]}
                onClick = {() => this.checkAnswer(this.state.answers[i][0])}
            />
        );
    }
    
    
    render() {
    //State defining menu
    if(this.state.mainState === 0){
        return (
        <div className={cssGame0}>
            <div className={cssTitle}>VFR Instruments</div>
            <div className={cssInstructions}>VFR Instruments are the ones that the FAA requires you to have in order to fly in accordance with visual flight (VFR) during the day. The mnemonic "A TOMATO FLAMES" represents these instruments. The following exercise will ask that you select the instrument represented by each letter, in order.</div>
            <StartButton onClick={() => this.setupGame()}
                        value = "Begin"></StartButton>
        </div>
        );
    }
    //State defining the game
    else if(this.state.mainState === 1){
        return (
        <div className={cssGame}>
            <div className={cssHeader}>
                <div className={this.state.question === 0 ? cssHeaderLetterHighlighted : (this.state.question > 0 ? cssHeaderLetterComplete : cssHeaderLetter)}>A </div>
                <div className={this.state.question === 1 ? cssHeaderLetterHighlighted : (this.state.question > 1 ? cssHeaderLetterComplete : cssHeaderLetter)}>T</div>
                <div className={this.state.question === 2 ? cssHeaderLetterHighlighted : (this.state.question > 2 ? cssHeaderLetterComplete : cssHeaderLetter)}>O</div>
                <div className={this.state.question === 3 ? cssHeaderLetterHighlighted : (this.state.question > 3 ? cssHeaderLetterComplete : cssHeaderLetter)}>M</div>
                <div className={this.state.question === 4 ? cssHeaderLetterHighlighted : (this.state.question > 4 ? cssHeaderLetterComplete : cssHeaderLetter)}>A</div>
                <div className={this.state.question === 5 ? cssHeaderLetterHighlighted : (this.state.question > 5 ? cssHeaderLetterComplete : cssHeaderLetter)}>T</div>
                <div className={this.state.question === 6 ? cssHeaderLetterHighlighted : (this.state.question > 6 ? cssHeaderLetterComplete : cssHeaderLetter)}>O</div>
                <div className={this.state.question === 7 ? cssHeaderLetterHighlighted : (this.state.question > 7 ? cssHeaderLetterComplete : cssHeaderLetter)}>F</div>
                <div className={this.state.question === 8 ? cssHeaderLetterHighlighted : (this.state.question > 8 ? cssHeaderLetterComplete : cssHeaderLetter)}>L</div>
                <div className={this.state.question === 9 ? cssHeaderLetterHighlighted : (this.state.question > 9 ? cssHeaderLetterComplete : cssHeaderLetter)}>A</div>
                <div className={this.state.question === 10 ? cssHeaderLetterHighlighted : (this.state.question > 10 ? cssHeaderLetterComplete : cssHeaderLetter)}>M</div>
                <div className={this.state.question === 11 ? cssHeaderLetterHighlighted : (this.state.question > 11 ? cssHeaderLetterComplete : cssHeaderLetter)}>E</div>
                <div className={this.state.question === 12 ? cssHeaderLetterHighlighted : (this.state.question > 12 ? cssHeaderLetterComplete : cssHeaderLetter)}>S</div>
            </div>
        <Answer style={cssBlank}
            />
        
            {this.renderAnswer(0)}
            {this.renderAnswer(1)}
            {this.renderAnswer(2)}
            {this.renderAnswer(3)}
            {this.renderAnswer(4)}
            {this.renderAnswer(5)}
            {this.renderAnswer(6)}
            {this.renderAnswer(7)}
            {this.renderAnswer(8)}
            {this.renderAnswer(9)}
            {this.renderAnswer(10)}
            {this.renderAnswer(11)}
            {this.renderAnswer(12)}
        </div>
    );    
        
    }
    else{
        var numberOnFirstTry = 0;
        for(let i = 0; i < this.state.onFirstTry.length; i++){
            if(this.state.onFirstTry[i] === true) numberOnFirstTry++;
        }
        var textToDisplay = "";
        if(numberOnFirstTry === 13) textToDisplay = "Congrats! You got all of them right on the first try! Click restart if you would like more practice.";
        else textToDisplay = "You scored " + numberOnFirstTry + "/13 on your first try. Try to make that number 13!";
        return(
            <div className={cssGame0}>
            <div className={cssScore}>{textToDisplay}</div>
            <StartButton onClick={() => this.setupGame()}
                        value = "Restart"></StartButton>
            </div>
        );
    }
    
  }
}

//Renders the entire app
ReactDOM.render(
  <Game />,
  document.getElementById('root')
);



//Shuffle the array using Fisher-Yates Algorithm
function shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {

        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }

    return array;
}



/*
***OLD TIC TAC TOE CODE***
function Square(props) {
    return (
      <button className="square" onClick={props.onClick}>
        {props.value}
      </button>
    );
  }

class Board extends React.Component {
  
    constructor(props){
        super(props);
        this.state = {
            squares: Array(9).fill(null),
            xIsNext: true,
        }
    }
    
    handleClick(i){
        const squares = this.state.squares.slice();
        if(calculateWinner(squares) || squares[i]) return;
        squares[i] = this.state.xIsNext ? 'X' : 'O';
        this.setState({
            squares: squares,
            xIsNext : !this.state.xIsNext,
            });
    }
    
    renderSquare(i) {
    return (
        <Square 
            value={this.state.squares[i]} 
            onClick={() => this.handleClick(i)}
        />
    );
  }

  render() {
    const winner = calculateWinner(this.state.squares);
    let status;
    if(winner){
        status = "Winner: " + winner;
    } else {
        status = 'Next player: ' + (this.state.xIsNext ? 'X' : 'O');
    }

    return (
      <div>
        <div className="status">{status}</div>
        <div className="board-row">
          {this.renderSquare(0)}
          {this.renderSquare(1)}
          {this.renderSquare(2)}
        </div>
        <div className="board-row">
          {this.renderSquare(3)}
          {this.renderSquare(4)}
          {this.renderSquare(5)}
        </div>
        <div className="board-row">
          {this.renderSquare(6)}
          {this.renderSquare(7)}
          {this.renderSquare(8)}
        </div>
      </div>
    );
  }
}

class Game extends React.Component {
  render() {
    return (
      <div className="game">
        <div className="game-board">
          <Board />
        </div>
        <div className="game-info">
          <div>{}</div> 
          <ol>{}</ol>  
        </div>
      </div>
    );
  }
}

// ========================================

ReactDOM.render(
  <Game />,
  document.getElementById('root')
);


function calculateWinner(squares){
    const lines = [
        [0, 1, 2],
        [3, 4, 5],
        [6, 7, 8],
        [0, 3, 6],
        [1, 4, 7],
        [2, 5, 8],
        [0, 4, 8],
        [2, 4, 6],
    ];
    for(let i = 0; i < lines.length; i++){
        const [a, b, c] = lines[i];
        if(squares[a] && squares[a] === squares[b] && squares[a] === squares[c]){
            return squares[a];
        }
    }
    return null;
}
*/




// WEBPACK FOOTER //
// ./src/index.js